/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react'
import FlowAssistant from '../../../../../../libs/api/services/FlowAssistant'
import StickyNavigationContext from '../../../../../../libs/providers/StickyNavigationProvider'
import { CalendarFacilityProvider } from '../../../../calendar/facility/CalendarFacilityProvider'
import Wizard from '../../../../common/wizard/Wizard'
import WorkFlowConfigurationContext, { WorkFlowConfigurationProvider } from '../../WorkFlowConfigurationProvider'
import WorkFlowLogs from './components/WorkFlowLogs'
import AddEventWizardEventTasks from './screens/AddEventWizardEventTasks'
import AddEventWizardEventTriggeredBy from './screens/AddEventWizardEventTriggeredBy'
import WorkFlowSetupType from './screens/WorkFlowSetupType'


export default function WorkflowWizard({ startStep, subsection, modalMode, onUseWorkflow }) {

    const [step, setStep] = useState(1)
    const [navigation, setNavigation] = useState([])
    const [values, setValues] = useState({})
    const { setSticky, setPreventMessage } = useContext(StickyNavigationContext)

    const _handleSetValues = (s) => {
        setValues(s)
        if (subsection) {
            subsection.setValues(s)
        }
    }
    useEffect(() => {
        if (subsection)
            setValues({ ...values, ...subsection.values })
    }, [subsection])
    const _handleSetNavigation = async (n) => {
        //alert(JSON.stringify(n))
        if (subsection) {
            subsection.navigation(n)
        } else {
            var _nav = []
            var history = FlowAssistant
                .GetLast()
            if (step === 0) {
                if (startStep)
                    setStep(startStep)

                if (history) {
                    var vs = {}
                    for (const k of Object.keys(history.details)) {
                        // const parsed = JSON.parse(history.details[k])
                        try {
                            vs[k] = JSON.parse(history.details[k])
                        } catch (e) {
                            vs[k] = history.details[k]
                        }
                        // setValues({ ...values, ...vs })
                    }
                }
            }
            if (history) {
                _nav.push({ type: 'Action', action: () => FlowAssistant.Goto(history.section), text: 'Cancel' })
            }

            _nav = [..._nav, ...n]
            // In flow jumping
            if (values.action && values.action.from) {
                // _nav = [{ text: 'Done', type: 'Step', step: values.action.from, action: async () => { _handleSetValues({ ...values, action: {} }) } }]
                _nav = [{ text: 'Back', type: 'Step', step: values.action.from, action: async () => { _handleSetValues({ ...values, action: {} }) } }]
                // setValues({ ...values, action: {} })
            }
            setNavigation(_nav)
        }
    }

    useEffect(() => {
        if (values.action && values.action.to) {
            try { setStep(values.action.to) } catch (e) { }
        }
    },
        [values]
    )

    const _hasLast = async () => {
        const Last = await FlowAssistant
            .GetLast()
        if (Last) {
            switch (Last.section) {
                case 'NEW_EVENT_WORKFLOW_ADD_EVENT':
                case 'NEW_EVENT_WORKFLOW_GENERATE_FORM':
                case 'NEW_EVENT_WORKFLOW_SEND_QUESTIONNAIRE':
                    FlowAssistant.HasRedirected(Last)
                    _handleSetValues(Last.details)
                    setStep(3)
                    break;
                case 'MANAGE_WORKFLOW_EVENT':
                    FlowAssistant.HasRedirected(Last)
                    _handleSetValues(Last.details)
                    setStep(1)
                    break;
                default:
                    break;
            }
        }
    }
    return (
        <WorkFlowConfigurationProvider>
            <CalendarFacilityProvider>
                <InnerSeeding subsection={subsection}>
                    <Wizard sections={[
                        <WorkFlowSetupType modalMode={modalMode} onUseWorkflow={onUseWorkflow} />,
                        <AddEventWizardEventTriggeredBy name="workflow-triggers" />,
                        <AddEventWizardEventTasks name="workflow-tasks" />,
                        <WorkFlowLogs name="workflow-logs" />,
                    ]}
                        onNavigate={(step) => {
                            // Check if sticky
                            if (step !== 1 && step !== 5) {
                                setSticky(true)
                                setPreventMessage('Configuration Incomplete', 'You have not completed the configuration process. <br/><br/>This can be completed later, however service will not be active until completed. <br/><br/>Are you sure you would like to cancel?')
                            } else {
                                setSticky(false)
                            }
                            return true
                        }}
                    />
                </InnerSeeding>
            </CalendarFacilityProvider>
        </WorkFlowConfigurationProvider>
    )
}

function InnerSeeding({ subsection, children }) {
    const ctx = useContext(WorkFlowConfigurationContext)
    useEffect(() => {
        try {
            if (subsection && subsection.values) {
                const { category, event } = subsection.values
                if (category) {
                    // selectCategory expects an object wrapper { object: category }
                    try { ctx.selectCategory({ object: category }) } catch (e) { }
                    // loadEvents reads state.category which is updated asynchronously.
                    // Queue loadEvents on the next microtask to avoid a race where state.category is still undefined.
                    try { Promise.resolve().then(() => ctx.loadEvents()).catch(() => { }) } catch (e) { }
                }
                if (event) {
                    // set the event after events are loaded
                    try { Promise.resolve().then(() => ctx.setEvent({ object: event })).catch(() => { }) } catch (e) { }
                }
            }
        } catch (e) { }
    }, [subsection])
    return children
}
